import React from 'react';
import styled from 'styled-components';
import { Avatar } from 'antd';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  background-color: #eee;
  display: flex;
  flex-direction: row;
  margin-bottom: 40px;
  padding: 20px;
  border-radius: 10px;
  min-height: 100px; /* Consistent height for all organizer boxes */
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #e0e0e0;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

const NameBio = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 30px;
`;

const Name = styled.span`
  font-size: 1.1rem;
`;

const Bio = styled.span`
  font-size: 0.9rem;
  color: gray;
  margin-top: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
  max-height: 2.8em; /* 2 lines with line-height 1.4 */
`;

function OrganizerBox({ avatar, user, bio }) {
  const navigate = useNavigate();
  
  const handleClick = () => {
    if (user && user.id) {
      navigate(`/profile/${user.id}`);
    }
  };
  
  return (
    <Container onClick={handleClick}>
      <div>
        <Avatar size={60} src={avatar} />
      </div>
      <NameBio>
        <Name>{user && `${user.first_name} ${user.last_name}`}</Name>
        <Bio>{bio}</Bio>
      </NameBio>
    </Container>
  );
}

export default OrganizerBox;
